// Feature flag for the standalone "/comix/themes" genre-picker step shown to
// brand-new visitors before character creation. Off by default — set
// NEXT_PUBLIC_FEATURE_COMIX_THEMES=true to re-enable. When off, every entry
// point routes straight past it (home CTA, the /comix/select back button, and
// the page itself if someone lands on it directly via an old link/bookmark).
export const COMIX_THEMES_ENABLED = process.env.NEXT_PUBLIC_FEATURE_COMIX_THEMES === 'true';

// Holiday Chaos swaps into the picker where Romantic sits. When on, Romantic is hidden and the
// Holiday Chaos card (a Modern Funny story set at Christmas, cast in Christmas outfits) is shown.
// ON by default — set NEXT_PUBLIC_FEATURE_COMIX_CHRISTMAS_FUN=false to turn it off (and bring
// Romantic back). NEXT_PUBLIC_* is inlined at build time, so a change needs a redeploy.
export const COMIX_CHRISTMAS_FUN_ENABLED = process.env.NEXT_PUBLIC_FEATURE_COMIX_CHRISTMAS_FUN !== 'false';

// The /comix/select "add a second character" nudge (the pink heart banner). It used to
// appear only when the visitor had picked a relationship-driven theme (Romantic / Spicy
// Hot) in the themes step. That step is off by default now (COMIX_THEMES_ENABLED above),
// so by default the nudge is shown to everyone who still has a single character. Set
// NEXT_PUBLIC_FEATURE_RELATIONSHIP_NUDGE_THEME_ONLY=true to restore the old behavior where
// it only shows for a relationship-driven theme selection.
export const RELATIONSHIP_NUDGE_THEME_ONLY =
  process.env.NEXT_PUBLIC_FEATURE_RELATIONSHIP_NUDGE_THEME_ONLY === 'true';

// Christmas Love (genre/theme id 'romantic-christmas') toggles with Old Mystery. When on, Old
// Mystery is hidden and the Christmas Love card (a couple's Christmas story, cast in Christmas
// outfits) is shown. ON by default — set NEXT_PUBLIC_FEATURE_COMIX_ROMANTIC_CHRISTMAS=false
// to turn it off (and bring Old Mystery back). NEXT_PUBLIC_* is inlined at build time, so a
// change needs a redeploy.
export const COMIX_ROMANTIC_CHRISTMAS_ENABLED =
  process.env.NEXT_PUBLIC_FEATURE_COMIX_ROMANTIC_CHRISTMAS !== 'false';
